import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import { typography, spacing } from "../../styles/designSystem";

const Card = styled.div`
  background-color: ${({ theme }) => theme.cardBackground || theme.background};
  border: 1px solid ${({ theme }) => theme.borderLight};
  padding: ${spacing[600]};
  width: 100%;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  position: relative;
  /* Recessed like every other panel on the site, rather than lifted off the page. */
  box-shadow: inset 0 0 40px rgba(0, 0, 0, 0.5);
  height: 100%;
`;

const QuoteIcon = styled(FontAwesomeIcon)`
  /* theme.accent does not exist in either theme, so this used to fall back to a
     leftover blue on every case study. The quote mark is phosphor like everything else. */
  color: ${({ theme }) => theme.primary};
  font-size: ${typography.fontSize[400]};
  margin-bottom: ${spacing[400]};
`;

const Body = styled.p`
    font-size: ${typography.fontSize[300]};
    font-weight: ${typography.fontWeight.medium};
    line-height: ${typography.lineHeight[400]};
    color: ${({ theme }) => theme.text};
    margin: 0;
`;

const Attribution = styled.div`
    margin-top: auto;
    padding-top: ${spacing[400]};
`;

const Name = styled.p`
    font-weight: ${typography.fontWeight.bold};
    font-size: ${typography.fontSize.base};
    margin: 0;
`;

const Title = styled.p`
    font-size: ${typography.fontSize[200]};
    color: ${({ theme }) => theme.subtleText || theme.text};
    margin: ${spacing[100]} 0 0;
    font-style: italic;
`;

const TestimonialCard = ({ name, title, body }) => (
    <Card>
        <QuoteIcon icon={faQuoteLeft} />
        <Body>{body}</Body>
        <Attribution>
            <Name>{name}</Name>
            <Title>{title}</Title>
        </Attribution>
    </Card>
);

export default TestimonialCard;
